var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#5F5F5F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_1911)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -304,
    y: -1889,
    width: 1920,
    height: 6538,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 1380",
    opacity: 0.15,
    filter: "url(#filter0_f_104_1911)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -167.605,
    cy: 636.753,
    rx: 618.828,
    ry: 407.606,
    transform: "rotate(-3.41582 -167.605 636.753)",
    fill: "#8467FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 47253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 47245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    clipPath: "url(#clip1_104_1911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.2527 8.43711L23.2947 1.07027C22.553 0.459935 21.2693 0 20.3088 0H6.21759C4.99938 0 4.00806 0.991133 4.00806 2.20953C4.00806 2.20953 4.00806 22.4156 4.00806 28.9611C4.00806 29.3644 4.22659 29.2507 4.28827 29.1855C4.57645 28.8808 5.45931 27.9836 5.45931 27.9836C5.45931 27.9836 5.64435 27.8222 5.64435 27.4189C5.64435 21.2591 5.64435 2.20953 5.64435 2.20953C5.64435 1.89876 5.90701 1.63629 6.21759 1.63629H20.3088C20.5476 1.63629 21.046 2.19368 21.046 2.44457V9.15164C21.046 10.37 22.0371 11.3612 23.2553 11.3612H31.5797C31.7315 11.3612 31.9887 11.4654 31.9887 11.8332C31.9887 11.8387 31.9897 32.5991 31.9897 32.5991C31.9897 32.9153 31.7325 33.1724 31.4163 33.1724C31.4163 33.1724 15.5842 33.1724 10.4969 33.1724C9.99253 33.1724 9.68679 33.4772 9.68679 33.4772C9.68679 33.4772 8.93592 34.2053 8.7153 34.4745C8.65011 34.554 8.48614 34.8086 8.9549 34.8086C14.4278 34.8086 31.4163 34.8086 31.4163 34.8086C32.6348 34.8086 33.6258 33.8176 33.6258 32.5992V11.3441C33.6256 10.3306 33.0352 9.08075 32.2527 8.43711ZM23.2553 9.72487C22.9393 9.72487 22.6821 9.46781 22.6821 9.15164V2.82822L30.7542 9.72487H23.2553Z",
    fill: "#0085FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.0937 30.234C17.0747 30.234 18.9271 29.4528 20.3094 28.0339C23.111 25.158 23.0509 20.5394 20.1752 17.7377C18.8078 16.4053 17.0036 15.6716 15.0946 15.6716C13.1134 15.6716 11.2613 16.453 9.87879 17.872C7.07733 20.7475 7.13749 25.3663 10.013 28.1682C11.3803 29.5004 13.185 30.234 15.0937 30.234ZM11.0507 19.0137C12.1223 17.9137 13.5585 17.3078 15.0946 17.3078C16.5746 17.3078 17.9732 17.8768 19.0334 18.9096C21.2627 21.0818 21.3094 24.6627 19.1377 26.8921C18.0659 27.992 16.6296 28.598 15.0938 28.598C13.6137 28.598 12.215 28.0292 11.1549 26.9963C8.92542 24.8241 8.87874 21.2431 11.0507 19.0137Z",
    fill: "#0085FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.2771 29.8809C9.77425 29.6254 9.44175 29.3069 9.19807 29.0616C9.02471 28.8871 8.60235 28.427 8.32366 27.9582C8.29405 27.9082 8.21548 27.83 8.08235 27.95L2.52992 33.6491C2.31841 33.8663 2.32287 34.2167 2.53979 34.4283L3.98744 35.8442C4.20445 36.0557 4.55507 36.0515 4.7664 35.8343L10.2704 30.185C10.4204 30.0348 10.3886 29.9375 10.2771 29.8809Z",
    fill: "#0085FF"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_104_1911",
    x: -1000.32,
    y: 13.6779,
    width: 1665.43,
    height: 1246.15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 107.25,
    result: "effect1_foregroundBlur_104_1911"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_1911"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -304,
    y: -1889,
    width: 1920,
    height: 6538,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_104_1911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyy);
export default __webpack_public_path__ + "static/media/copyy.62802c018cd8136c834286ac61d42ae4.svg";
export { ForwardRef as ReactComponent };